import React from 'react'
import PropTypes from 'prop-types'

class BoxIcon extends React.Component {
  render() {
    const { size, color, strong, children } = this.props
    const style = {
      size: size,
      color: color
    }

    return (
      <div style={style}>
        {
          strong ? <strong>{children}</strong> : {children}
        }
      </div>
    )
  }
}

BoxIcon.propTypes = {
  size: 14,
  color: '#333',
  strong: false
}

BoxIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  strong: PropTypes.bool,
}

export default BoxIcon



// WEBPACK FOOTER //
// ./src/components/widgets/BoxIcon.js